<!-- src/app/savings-calculator/savings-calculator.component.html -->
<div class="savings-calculator">  
    <div>
        This calculator gives you an estimate of how much you could save by reducing your energy usage by a certain percentage.
        Adjust the slider to calculate the savings based on your reduced usage.
    </div>

    <div class="slider-container my-3">
        <h5>Input your estimated reduced usage here: (%)</h5>
        <div class="label-container">
            <label id="name-label" class="name-label">Reduced by </label>
            <label class="value-label">{{slider.value}}%</label>
        </div>
        <mat-slider style="width: 90%;" discrete min="1" max="100" step="1" [displayWith]="formatLabel">
            <input matSliderThumb [(ngModel)]="currentUsage" #slider>
        </mat-slider>
    </div>
  
    <div class="savings-display">
        <h5>Expected Usage: {{ nextEvent?.expectedUsage }}kWh</h5>
        <h5>Reduced Usage (estimated): {{ reducedUsage() | number:'1.2-2' }}kWh</h5>
        <h5>Estimated Savings: {{ savings() | currency:'GBP' }}</h5>
    </div>
  </div>
  